<p-dialog
  header="Change Assignee"
  [(visible)]="visible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  (onHide)="closeAssigneeDialog()"
>
  <div *ngIf="!assigneesLoading">
    <div class="grid align-items-center mb-2" style="height: 50px">
      <div class="col-4">
        <label>Assignee</label>
      </div>
      <div class="col-6">
        <p-dropdown
          appendTo="body"
          [options]="assigneeOptions"
          [filter]="true"
          [style]="{ width: '100%' }"
          [(ngModel)]="assignee"
          [group]="true"
        ></p-dropdown>
      </div>
      <div class="col-2">
        <!--        <p-button-->
        <!--          icon="fa fa-minus-circle ui-button ui-button-danger"-->
        <!--          (click)="assignee = null"-->
        <!--        ></p-button>-->
        <span class="link-style cursor-pointer" (click)="assignee = null">Remove</span>
      </div>
    </div>
    <div class="mb-2" *ngIf="showAssignAllExpenses">
      <p-checkbox
        [label]="getApplyToAllCheckboxText()"
        binary="true"
        [(ngModel)]="assignOtherPendingExpenses"
      ></p-checkbox>
    </div>
    <div class="mb-2" *ngIf="hideAssignAllCheckbox">
      {{ getAutoApplyToAllText() }}
    </div>
  </div>

  <div class="text-center" style="position: relative" *ngIf="assigneesLoading">
    <span><i class="fa fa-spin fa-spinner"></i></span>
  </div>

  <p-footer class="no-rounded-top-border rounded-bottom-border">
    <div style="text-align: right">
      <button
        type="button"
        (click)="closeAssigneeDialog()"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        [disabled]="saving"
        (click)="saveChangeAssignee()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
